import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '../shared/service/AppService.class';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DidService extends AppService<any>{

  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "dids";
  }

  getHeaders(data?:any): Observable<any>{
    let tmp=this.appmod
    this.appmod='custom/getHeaders'
    let result = super.getService(data);
    this.appmod=tmp
    return result;
  }
  getdidgroups(data?:any): Observable<any>{
    let tmp=this.appmod
    this.appmod='custom/getdidgroups'
    let result = super.getService(data);
    this.appmod=tmp
    return result;
  }

  
  public checkvalidlist(id,type): Observable<any> {
    let tmp=this.appmod
    this.appmod = "checkallliststatus";
    let result = super.getService(id,type);
    this.appmod=tmp
    return result;
  }
  
  public CountStateDID(groupID): Observable<any> {
    let tmp=this.appmod
    this.appmod = "countdidstate";
    let result = super.getService('', groupID);
    this.appmod=tmp
    return result;
  }
  public deleteFile(data: any,type:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/delete_didfile";
    let result = super.deleteService(data,type);
    this.appmod = tmp;
    return result;
  }
  public deleteGroup(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/deletedidGroup";
    let result = super.deleteService(data);
    this.appmod = tmp;
    return result;
  }
  public getdidReports(id:any): Observable<any> {
    let tmp=this.appmod
    this.appmod = "custom/getdidReports";
    let result = super.getService(id);
    this.appmod=tmp
    return result;
  }

  public getTopbox(id:any): Observable<any> {
    let tmp=this.appmod
    this.appmod = "custom/getdidTopbox";
    let result = super.getService(id);
    this.appmod=tmp
    return result;
  }

  public checkdidassign(id:any): Observable<any> {
    let tmp=this.appmod
    this.appmod = "getassigndidsdata";
    let result = super.getService(id);
    this.appmod=tmp
    return result;
  }


}
